/** Perfil de checkout guardado en el dispositivo (registro → carrito). */
export const CHECKOUT_PROFILE_STORAGE_KEY = 'fixglass_checkout_profile'

/**
 * @returns {{ version: number, dni_cuit?: string, phone?: string, shipping?: { street: string, number: string, neighborhood: string, city: string, postalCode: string, details: string } } | null}
 */
export function loadCheckoutProfile() {
  try {
    const raw = localStorage.getItem(CHECKOUT_PROFILE_STORAGE_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (!data || typeof data !== 'object') return null
    return data
  } catch {
    return null
  }
}

/**
 * @param {object} partial
 * @param {string} [partial.dni_cuit]
 * @param {string} [partial.phone]
 * @param {object} [partial.shipping]
 */
export function saveCheckoutProfile(partial) {
  try {
    const prev = loadCheckoutProfile() || { version: 1 }
    const { shipping: shipIn, ...rest } = partial
    const next = { version: 1, ...prev, ...rest }
    if (shipIn && typeof shipIn === 'object') {
      next.shipping = { ...(prev.shipping || {}), ...shipIn }
    }
    localStorage.setItem(CHECKOUT_PROFILE_STORAGE_KEY, JSON.stringify(next))
  } catch (e) {
    console.warn('No se pudo guardar el perfil de checkout', e)
  }
}
